import React, { useEffect } from 'react'
import Banner2 from '../components/Banner2';
import { Container } from 'react-bootstrap';
import Whyus from '../components/Whyus';
import Howwork from '../components/Howwork';
import Contact from '../components/Contact';
import { useDispatch, useSelector } from 'react-redux';
import { getCms } from '../features/cms/cmsSlice';
import { Link, useParams } from 'react-router-dom';
import i18n from '../MultiLanguage/i18n';
import ProductContainer from './ProductContainer';
import { useState } from 'react';
import { Loader } from "../components/common/loader";

const AboutPage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  const [lan, setLan] = useState(i18n.language);

  // // console.log("abotu page id", id);

  const { cmsLoader, title_en, content_en, title_ar, content_ar, status } = useSelector((state) => state.cms);
  // // console.log(title_en, 'title_en');
  // // console.log(content_en, 'content_en');
  // // console.log(status, 'status');


  // const getTitle = (id) => {
  //   switch (id) {
  //     case 'insurance':
  //       return 'Insurance';
  //     case 'about':
  //       return 'About Us';
  //     case 'privacy-policy':
  //       return 'Privacy Policy';
  //     default:
  //       return 'Page Not Found';
  //   }
  // };

  // const title = getTitle(id);

  // const lan = i18n.language;

  useEffect(() => {
    const handleLanguageChange = () => {
      setLan(i18n.language);
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  useEffect(() => {
    // Mapping `id` and `lan` to CMS keys
    const cmsKeyMap = {
      'contact': 'contact-us',
      'insurance': 'insurance-solutions',
      'about': 'about-us',
      'privacy-policy': 'privacy-policy',
      'faq': 'faq',
      'terms-and-conditions': 'terms-and-conditions',
      'request-tracking': 'request-tracking',

    };
    // // console.log("lan", lan);


    if (cmsKeyMap[id] && cmsKeyMap[id]) {
      dispatch(getCms(cmsKeyMap[id]));
    }

  }, [dispatch, lan, id]);

  useEffect(() => {
    if (lan === 'ar') {
      setTitle(title_ar);
      setContent(content_ar);
    }
    if (lan === 'en') {
      setTitle(title_en);
      setContent(content_en);
    }
  }, [lan, title_en, content_en, title_ar, content_ar, status]);

  if (cmsLoader) {
    return <Loader type="logo-gif" />
  }


  return (
    <>
      <div className='about-section'>
        {
          id === "contact" ?
            <div className='why-us'>
              <div
                className='text-center contact-text'
                dangerouslySetInnerHTML={{ __html: content || "<p className='text'>Not Found</p>" }}
              />
              <div className="social-media contact">
                <ul>
                  <li>
                    <Link to="https://www.instagram.com/mamman.om/" target="_blank">
                      <i className="bi bi-instagram"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="https://www.facebook.com/mamman.om" target="_blank">
                      <i className="bi bi-facebook"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="https://x.com/mamman_om" target="_blank">
                      <i className="bi bi-twitter-x"></i>
                    </Link>
                  </li>
                  <li>
                    <Link to="https://linkedin.com/company/mammanom " target="_blank">
                      <i className="bi bi-linkedin"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            :
            <Banner2>
              <div className='bg-img'>
                <img src={require('../assets/images/banner-02.png')} alt='img' className='img-fluid'></img>
              </div>
              <Container>
                <div className='policy-formBox about-content'>
                  <h3 className='title text-capitalize'>{title}</h3>
                  <div dangerouslySetInnerHTML={{ __html: content || '<p>Not Found</p>' }} />
                </div>
              </Container>
            </Banner2>
        }
        {
          id === "about" &&
          <>
            <Whyus />
            <Howwork />
          </>
        }
        {
          id === "insurance" &&
          <ProductContainer isAllProductPage={true} />
        }
        <Contact />
      </div>
    </>
  )
}

export default AboutPage;
